import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { RegistroObservacionesActividadesDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class RegistroObservacionesActividadesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getRegistroObservacionesActividadesService(): Observable<BodyListResponse<RegistroObservacionesActividadesDTO>> {
    return this.http.get<BodyListResponse<RegistroObservacionesActividadesDTO>>(API_URL + '/api/v1/registroObservacionesActividades/todos');
  }

  guardarRegistroObservacionesActividadesService(registroObservacionesActividadesDTO: RegistroObservacionesActividadesDTO): Observable<BodyResponse<RegistroObservacionesActividadesDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/registroObservacionesActividades', registroObservacionesActividadesDTO);
  }

  getRegistroObservacionesActividadesPorCodigoService(codigo: string): Observable<BodyResponse<RegistroObservacionesActividadesDTO>> {
    return this.http.get<BodyResponse<RegistroObservacionesActividadesDTO>>(API_URL + '/api/v1/registroObservacionesActividades/' + codigo);
  }
  /***********nuevo */
  getRegistroObservacionesActividadesPorCronogramaService(codigo:string): Observable<BodyListResponse<RegistroObservacionesActividadesDTO>> {
    return this.http.get<BodyListResponse<RegistroObservacionesActividadesDTO>>(API_URL + '/api/v1/registroObservacionesActividades/cronograma/'+codigo);
  }
}
